module.exports = __webpack_public_path__ + "static/media/desktopScreenshot03.06899dae.jpg";